import { create } from 'zustand';

interface LinkPreviewStore {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
}

export const useLinkPreviewStore = create<LinkPreviewStore>((set) => ({
  isOpen: false,
  setOpen: (open) => set({ isOpen: open }),
})); 